export const POLL_INTERVALS = {
  FAST: 2_000, // moderation status polling
  MEDIUM: 5_000, // ResourceDetails metrics polling
  SLOW: 30_000, // notification polling
} as const

export const PAGE_SIZE = {
  DEFAULT: 25,
  LARGE: 50,
  COMPACT: 10,
} as const

export const STORAGE_PREFIX = {
  STUDIO_POST_DRAFT: 'studio-post-draft-v1',
  COMMAND_CENTER_POST_DRAFT: 'command-center-post-draft-v1',
  COMPOSER_PREFS: 'studio-post-composer-prefs-v1',
} as const

export const QUERY_STALE_TIME = {
  SHORT: 30_000, // 30s — matches default
  MEDIUM: 5 * 60_000, // 5m
  LONG: 60 * 60_000, // 1h
} as const
